export enum HolderType {
    INDIVIDUAL = "INDIVIDUAL",

    BUSINESS = "BUSINESS"
}